import type { Endpoints } from '~/types'
import type { FetchError } from 'ofetch'
import type { RouteLocationNormalized } from '#vue-router'

export const useLoadActuPlay = () => {
  const actualitiesWapStore = useActualitiesWAPStore()
  const wapersStore = useWapersStore()
  const slidersStore = useDoNotMissStore()

  return async (route: RouteLocationNormalized) => {
    const slug = route.params.title as string
    const notFound = await actualitiesWapStore
      .fetchActuality({ slug })
      .then(() => false)
      .catch((error: FetchError) => error?.statusCode === 404)

    if (notFound) {
      // a corrected title moved the article: the former URL moves to the new one
      const { data } = await useCustomFetch<
        Endpoints['GET__ARTICLE_SLUG_REDIRECT']
      >(API.GET__ARTICLE_SLUG_REDIRECT.replace('$slug', slug))
      const current = unref(data)?.slug
      if (current && current !== slug) {
        return navigateTo(
          { path: `/actualites-playstation/${current}`, query: route.query },
          { redirectCode: 301 },
        )
      }

      throw createError({ statusCode: 404 })
    }

    await Promise.all([
      wapersStore.fetchUserWapers(),
      // Fetch another posts data
      actualitiesWapStore.fetchOtherActualities({ page: 1 }),
      // Fetch data for slider `Do Not Miss`
      slidersStore.fetchDoNotMiss(),
    ])
  }
}
